import React from 'react';
import { ArrowDown, ArrowUp } from 'lucide-react';

/**
 * Klickbarer Teil einer Spaltenüberschrift. Für Tabellen, die ihre Kopfzellen
 * selbst mitbringen (z. B. shadcn `TableHead`) — dann bleibt deren Aussehen.
 */
export function SortButton({ sortKey, sort, onSort, children, testIdPrefix = 'sort', reverse = false }) {
  const active = sort?.key === sortKey;
  const dir = active ? sort.dir : 'asc';
  const Arrow = active && dir === 'desc' ? ArrowDown : ArrowUp;
  return (
    <button
      type="button"
      onClick={() => onSort(sortKey)}
      className={`inline-flex items-center gap-1 uppercase tracking-wider hover:text-brand-red ${
        reverse ? 'flex-row-reverse' : ''
      } ${active ? 'text-brand-red font-semibold' : ''}`}
      data-testid={`${testIdPrefix}-${sortKey}`}
      title={`Nach ${typeof children === 'string' ? children : 'Spalte'} sortieren`}
      aria-label={`Nach ${typeof children === 'string' ? children : 'Spalte'} sortieren`}
    >
      <span>{children}</span>
      <Arrow className={`w-3 h-3 shrink-0 ${active ? '' : 'opacity-30'}`} />
    </button>
  );
}

/**
 * Kopfzelle mit klickbarer Überschrift. Ohne `onSort` bleibt sie eine gewöhnliche
 * Zelle, damit sich nicht sortierbare Spalten nicht als klickbar ausgeben.
 */
export default function SortableTh({
  sortKey,
  sort,
  onSort,
  children,
  className = 'p-4 text-left',
  testIdPrefix = 'sort',
  align = 'left',
}) {
  if (!onSort || !sortKey) {
    return <th className={className}>{children}</th>;
  }
  const active = sort?.key === sortKey;
  const dir = active ? sort.dir : 'asc';
  return (
    <th className={className} aria-sort={active ? (dir === 'desc' ? 'descending' : 'ascending') : 'none'}>
      <SortButton
        sortKey={sortKey}
        sort={sort}
        onSort={onSort}
        testIdPrefix={testIdPrefix}
        reverse={align === 'right'}
      >
        {children}
      </SortButton>
    </th>
  );
}
